import { appInfo } from '../config/appinfo'

export interface IssueReportPayload {
  session_id: string | null
  description: string | null
  category: string | null
  screenshot_base64: string | null
  course_id: number | null
  module_id: number | null
  concept_id: number | null
  page_url: string | null
  user_agent: string | null
  client_timestamp: string
}

export const issuesAPI = {
  report: (payload: IssueReportPayload) =>
    fetch(`${appInfo.apiDomain}/api/issues/report`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
}
